import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/DashboardReportMetadataQuery'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class DashboardReportMetadataQueryStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "DashboardReportMetadataQueryStore",
			variables: true,
		})
	}
}

export async function load_DashboardReportMetadataQuery(params) {
  await initClient()

	const store = new DashboardReportMetadataQueryStore()

	await store.fetch(params)

	return {
		DashboardReportMetadataQuery: store,
	}
}
